import { connect } from 'react-redux';

import TabBar from './TabBar';
import { setSelectedFinancing } from '../../common/settings/actions';

const mapStateToProps = state => ({
    selectedFinancing: state.settings.selectedFinancing,
    doughnutSlider: state.settings.doughnutSlider,
    setSelectedFinancing: state.settings,
    loanProvider: state.loan.loanProvider,
    showPPA: state.ppa.showPPA,
    showLoan: state.loan.showLoan,
    showOBS: state.obs.showOBS,
    showCAP: state.cap.showCAP,
    provider: state.utility.provider,
    companyName: state.clientInfoUI.companyName,
    cashprice: state.solar.cashprice,
    includeCash: state.cash.includeCash,
    firstName: state.contactUI.firstName,
    lastName: state.contactUI.lastName,
    resiToggle: state.tax.resiToggle,
    includeESS: state.ess.includeESS,
});
const combinedActions = {
    setSelectedFinancing,
};

export default connect(
    mapStateToProps,
    combinedActions,
)(TabBar);



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/index.js